// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b351793f","404":"e1fbf898","498":"e748d7c2","787":"f0eac8bd"}[chunkId] + ".chunk.js";
};